import { useMeQuery } from '@/src/features/auth/services/useMeQuery'

import type { TConversationApi } from '../api/types/messageApi.types'

export const useConversationContact = (conversationUsers?: TConversationApi['conversationUsers']) => {
  const { data: me } = useMeQuery()
  return conversationUsers?.find(({ user }) => user.id !== me?.id)?.user
}
